import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  closeContinue(event) {
    $(event.currentTarget).closest(".modal").modal("hide");
  }
}
